import { Moment } from 'moment';


export type DateRangeValue  = {
    startDate: Moment | null,
    endDate: Moment | null,
} | null;
